import React from 'react';

const Features = () => (
  <section className="features-page">
    <h1>Features of Hestia Ledger</h1>
    <p>Simplify your financial tracking—personal or small business, it’s built for you.</p>
    <div className="features-grid">
      <div className="feature-item">
        <div className="feature-image">Image not available</div>
        <h2>Cloud Storage</h2>
        <p>Securely store your data in the cloud, linked to your account. Access anywhere, anytime. <em>(Full version)</em></p>
      </div>
      <div className="feature-item">
        <div className="feature-image">Image not available</div>
        <h2>Bills & Income</h2>
        <p>Track recurring charges and income with ease. Stay on top of your cash flow. <em>(Full version)</em></p>
      </div>
      <div className="feature-item">
        <div className="feature-image">Image not available</div>
        <h2>Excel Import/Export</h2>
        <p>Seamlessly import and export your data with Excel (.xlsx) files. <em>(Full version)</em></p>
      </div>
      <div className="feature-item">
        <div className="feature-image">Image not available</div>
        <h2>PDF Export</h2>
        <p>Generate clean PDF reports of your financials in a snap. <em>(Full version)</em></p>
      </div>
      <div className="feature-item">
        <div className="feature-image">Image not available</div>
        <h2>Personal Data Management</h2>
        <p>Manage your data with JSON imports and exports—total control. <em>(Full version)</em></p>
      </div>
      <div className="feature-item">
        <div className="feature-image">Image not available</div>
        <h2>Calendar</h2>
        <p>View and manage entries with a clickable calendar component. <em>(Full version)</em></p>
      </div>
      <div className="feature-item">
        <div className="feature-image">Image not available</div>
        <h2>Easy Input Form</h2>
        <p>Add new transactions fast with a user-friendly form. <em>(Free & Full versions)</em></p>
      </div>
    </div>
    <div className="features-cta">
      <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
    </div>
  </section>
);

export default Features;